import { FloatingDroppableArea } from "@circle-react-shared/BuilderUI/FloatingDropZone/FloatingDroppableArea";
import type { DropZonePosition } from "@circle-react-shared/BuilderUI/Store/types";

export interface FloatingDropZoneItemProps extends DropZonePosition {}

export const FloatingDropZoneItem = ({
  top,
  left,
  width,
  height,
  path,
  index,
  accepts,
  rejects,
}: FloatingDropZoneItemProps) => (
  <div
    key={`${path}:${index}`}
    className="pointer-events-none z-10"
    style={{
      position: "absolute",
      top,
      left,
      width,
      height,
    }}
    data-testid="builder-ui-floating-drop-zone-item"
    data-path={path}
    data-index={index}
    data-accepts={JSON.stringify(accepts)}
    data-rejects={JSON.stringify(rejects)}
  >
    <FloatingDroppableArea
      path={path}
      index={index}
      accepts={accepts}
      rejects={rejects}
    />
  </div>
);
